{
  "commonHeader": {
    "upgradeToPro": "Uaktualnij",
    "learnMore": "Dowiedz się więcej",
    "AIProductivitySuite": {
      "title": "Pakiet produktywności AI",
      "desc": "Zamień inspirujące dyskusje w imponujące rezultaty."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Zarządzaj kontem swojej organizacji za pomocą AI",
        "description": "Uzyskuj inteligentne odpowiedzi na pytania dotyczące konta i pomoc w nawigacji po ustawieniach.",
        "terms": "Korzystając z funkcji beta Zoom, zgadzasz się na {0}",
        "termsText": "Warunki programu beta Zoom"
      },
      "diveDeeper": "Poznaj szczegóły",
      "shareFeedback": "Przekaż opinię w {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Zadaj pytanie dotyczące konta organizacji",
      "heroInvite": "Jak zaprosić nowego użytkownika do mojego konta?",
      "heroGroups": "Jak przypisać użytkowników do grup?",
      "heroRoles": "Jak zarządzać rolami i uprawnieniami?"
    },
    "backMainAccount": "Powrót do konta głównego",
    "discoverProducts": "Odkryj produkty",
    "pricing": "Cennik",
    "more": "Więcej",
    "sidebarExpanded": "rozwinięty",
    "sidebarCollapsed": "zwinięty",
    "search": "Szukaj",
    "users": "Użytkownicy",
    "settings": "Ustawienia konta",
    "navigation": "Nawigacja",
    "clear": "Wyczyść",
    "searchPlaceholderAll": "Szukaj użytkowników, ustawień konta lub nawigacji",
    "searchPlaceholderUsers": "Szukaj użytkowników lub nawigacji",
    "searchPlaceholderSettings": "Szukaj ustawień konta lub nawigacji",
    "searchPlaceholderNav": "Szukaj w nawigacji",
    "searchGuide": "Wpisz słowa kluczowe, aby rozpocząć wyszukiwanie",
    "installOnDesktop": "Zainstaluj na komputerze",
    "downloadCenter": "Centrum pobierania",
    "getInTouch": "Skontaktuj się z nami",
    "featuredProduct": "wyróżniony produkt",
    "logo": {
      "adminCenter": "Centrum administracyjne",
      "subAccount": "Zarządzanie kontem podrzędnym",
      "externalAccount": "Zarządzanie kontem delegowanym"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Dowiedz się więcej",
      "gotIt": "Rozumiem"
    },
    "coachMark": {
      "dvsTipsTitle": "Dywizje są już dostępne",
      "dvsTipsContent": "Dywizje służą do tworzenia wielu instancji określonych produktów Zoom na Twoim koncie."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Dowiedz się więcej",
      "gotIt": "Rozumiem"
    },
    "coachMark": {
      "extAccountTipsTitle": "Zarządzaj kontami zewnętrznymi",
      "extAccountTipsContent": "Chcesz zarządzać innym kontem? Po prostu wyślij prośbę — po jej zatwierdzeniu zyskasz dostęp!"
    }
  },
  "feedback": {
    "dialogTitle": "Zostaw informacje zwrotne",
    "itemLableForProductArea": "Obszar produktu",
    "itemLableForSatisfied": "Jak bardzo jesteś zadowolony(-a) ze swoich doświadczeń?",
    "dissatisfied": "Bardzo duże niezadowolenie",
    "satisfied": "Bardzo duże zadowolenie",
    "itemLableForFeedback": "Informacje zwrotne",
    "placeholder": "Dziękujemy za Twoje pomysły, komentarze i sugestie.",
    "btnCancel": "Anuluj",
    "btnSubmit": "Prześlij",
    "supportTips": "Aby uzyskać wsparcie techniczne, odwiedź",
    "btnSupport": "Pomoc.",
    "messages": {
      "success": "Dziękujemy za informacje zwrotne!",
      "productFailed": "Obszar produktu jest wymagany.",
      "scoreFailed": "Wynik zadowolenia jest wymagany."
    },
    "products": {
      "General": "Ogólne",
      "AI": "AI",
      "Apps": "Aplikacje",
      "Calendar": "Kalendarz",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Poczta",
      "Meetings": "Spotkania",
      "Notes": "Notatki",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Harmonogram",
      "Tasks": "Zadania",
      "TeamChat": "Czat zespołowy",
      "WebinarsAndEvents": "Webinary i wydarzenia",
      "Whiteboard": "Tablica",
      "WorkflowAutomations": "Automatyzacje przepływu pracy",
      "WorkspaceReservation": "Rezerwacja przestrzeni roboczej",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "To zrzeczenie odpowiedzialności zostało wygenerowane przez administratora Twojego konta.",
    "cancel": "Anuluj",
    "agree": "Zgadzam się"
  },
  "shared": {
    "sideMenu": {
      "personal": "Osobiste",
      "admin": "Administrator",
      "menu": "Menu",
      "pinned": "Przypięte",
      "pin": "Przypnij",
      "unpin": "Odepnij",
      "moveItem": "Przenieś element",
      "myAccount": "Moje konto",
      "upgradeToPro": "Przejdź na Pro",
      "grabbedKeyboard": "Chwycono {0}. Użyj strzałek w górę i w dół, aby przenieść, spacji lub Enter, aby upuścić.",
      "dropped": "Upuszczono {0}.",
      "releasedUnchanged": "Zwolniono {0}, pozycja bez zmian.",
      "movedToPosition": "Przeniesiono {0} na pozycję {1} z {2}.",
      "movedUp": "Przeniesiono {0} w górę, pozycja {1} z {2}.",
      "movedDown": "Przeniesiono {0} w dół, pozycja {1} z {2}.",
      "movedUpNew": "Przeniesiono {0} w górę, nowa pozycja {1} z {2}",
      "movedDownNew": "Przeniesiono {0} w dół, nowa pozycja {1} z {2}",
      "cannotMoveFurther": "Nie można dalej przenieść {0}.",
      "grabbedMouse": "Chwycono {0}. Przesuń mysz, aby zmienić położenie, kliknij, aby upuścić, naciśnij Escape, aby anulować."
    },
    "item": "Element",
    "gotIt": "Rozumiem",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Dodano numer telefonu! Możesz go teraz używać do logowania i odzyskiwania konta.",
    "mfa_to_signin_phone_success": "{phone} jest teraz numerem logowania dla {email}.",
    "login_passkey_bound_success": "Klucz dostępu został pomyślnie utworzony"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Poniższe zaawansowane funkcje zarządzania będą miały zastosowanie tylko do użytkowników licencjonowanych i współpracujących.",
      "licensed_basic": "Poniższe zaawansowane funkcje zarządzania będą miały zastosowanie tylko do użytkowników licencjonowanych i podstawowych.",
      "licensed": "Poniższe zaawansowane funkcje zarządzania będą miały zastosowanie tylko do użytkowników licencjonowanych"
    },
    "support": "-  Obsługiwane w ustawieniach konta i ustawieniach grupy użytkowników",
    "archive_product": {
      "title": "Archiwizuj spotkania i webinary",
      "detail": "- Spotkania zostaną zarchiwizowane, gdy dołączą do nich użytkownicy na Twoim koncie. Aby skorzystać z tego ustawienia, zainstaluj<a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\"> aplikację do archiwizacji </a> z Zoom App Marketplace."
    },
    "restrict": {
      "title": "Ogranicz możliwość korzystania z wybranych funkcji przez użytkowników, kiedy dołączają do spotkania",
      "detail": "- Wybranych funkcji nie można używać nawet wówczas, kiedy prowadzący włączyli je na czas spotkań."
    },
    "meeting_integration": {
      "title": "Włącz integrację czatu podczas spotkania DLP (zapobieganie utracie danych)",
      "detail": "- Po włączeniu funkcja DLP będzie stosowana zarówno do publicznych, jak i prywatnych wiadomości czatu wysyłanych przez uczestnika. Wiadomości zostaną natychmiast usunięte, jeśli uczestnicy spotkania (wewnętrznego/zewnętrznego) rozmawiają na czacie, a wiadomość jest sprzeczna z zasadami zgodności organizacji hosta."
    },
    "chat_tool": {
      "title": "Narzędzie do etykiety czatu",
      "detail": "- Identyfikuj zdefiniowane słowa kluczowe i wzorce tekstowe w udostępnianych treściach oraz zapobiegaj udostępnianiu niechcianych wiadomości przez użytkowników."
    },
    "information_barriers": {
      "title": "Bariery informacyjne",
      "detail": "- Bariery informacyjne służą do kontroli komunikacji między wybranymi użytkownikami w celu zapewnienia zgodności z przepisami. Ograniczenia dotyczące spotkań i czatu mogą być nakładane między użytkownikami w dwóch grupach oraz na określonych użytkowników w związku z korzystaniem z określonych funkcji (np. czatu w trakcie spotkania, udostępniania ekranu i przesyłania plików). Ograniczenia te uniemożliwiają wymianę poufnych informacji między nieautoryzowanymi użytkownikami."
    },
    "dashboard": {
      "title": "Pulpit nawigacyjny",
      "detail": "- W przypadku pulpitu nawigacyjnego spotkań > poprzednich spotkań dane są wyświetlane tylko przez 3 miesiące dla wybranych użytkowników."
    },
    "reports": {
      "title": "Raporty",
      "detail": "- Niektóre raporty użytkowników wyświetlają dane tylko z 3 miesięcy dla wybranych użytkowników: raport o wyłączeniu odpowiedzialności, raport dziennika uczestnika, raport dzienników aktywności administratora oraz raport logowania/wylogowania."
    },
    "close": "Zamknij"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "Twój plan {planName} zostanie anulowany {cancelDate}. Przed tą datą możesz ponownie aktywować licencje webinarów. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby uzyskać dane dotyczące istniejących webinarów. Po {dataLossDate} stracisz wszystkie dane dotyczące webinarów.",
            "nonAdmin": "Twój plan {planName} zostanie anulowany {cancelDate}. Do tego dnia możesz skontaktować się z administratorem konta, aby ponownie aktywować licencje webinarów. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby uzyskać dane dotyczące istniejących webinarów. Po {dataLossDate} stracisz wszystkie dane dotyczące webinarów na Twoim koncie."
          },
          "admin": "Twój plan {planName} zostanie anulowany {cancelDate}. Do tego dnia możesz ponownie aktywować licencje webinarów. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby uzyskać {supportContent} dotyczące istniejących webinarów. Po {dataLossDate} stracisz wszystkie dane dotyczące webinarów na Twoim koncie.",
          "nonAdmin": "Twój plan {planName} zostanie anulowany {cancelDate}. Do tego dnia możesz skontaktować się z administratorem konta, aby ponownie aktywować licencje webinarów. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby uzyskać {supportContent} dotyczące istniejących webinarów. Po {dataLossDate} stracisz wszystkie dane dotyczące webinarów na Twoim koncie."
        },
        "expired": {
          "admin": "Twój plan {planName} został anulowany. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby uzyskać {supportContent} dla istniejących webinarów, albo ponownie kupić Zoom Webinars w celu przywrócenia dostępu do danych. Po {dataLossDate} stracisz wszystkie dane dotyczące webinarów na Twoim koncie.",
          "nonAdmin": "Twój plan {planName} został anulowany. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby uzyskać {supportContent} dla istniejących webinarów. Możesz też skontaktować się z administratorem konta w celu dokonania ponownego zakupu Zoom Webinars i przywrócenia dostępu do danych. Po {dataLossDate} stracisz wszystkie dane dotyczące webinarów na Twoim koncie."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "Twój plan {planName} zostanie wstrzymany {pausedDate} na {pauseDuration}. W okresie wstrzymania można wyświetlać tylko istniejące webinary i ich zasoby. W dowolnym momencie możesz anulować wstrzymanie i wznowić subskrypcję licencji webinarów.",
            "nonAdmin": "Twój plan {planName} zostanie wstrzymany {pausedDate} na {pauseDuration}. W okresie wstrzymania można wyświetlać tylko istniejące webinary i ich zasoby. W dowolnym momencie możesz skontaktować się z administratorem konta, aby anulować wstrzymanie i wznowić subskrypcję licencji webinarów."
          },
          "admin": "Twój plan {planName} zostanie wstrzymany {pausedDate} na {pauseDuration}. W okresie wstrzymania możesz wyświetlać tylko {supportContent}. W dowolnym momencie możesz anulować wstrzymanie i wznowić subskrypcję licencji webinarów.",
          "nonAdmin": "Twój plan {planName} zostanie wstrzymany {pausedDate} na {pauseDuration}. W okresie wstrzymania możesz wyświetlać tylko {supportContent}. W dowolnym momencie możesz skontaktować się z administratorem konta, aby anulować wstrzymanie i wznowić subskrypcję licencji webinarów."
        },
        "active": {
          "webinars": {
            "admin": "Twój plan {planName} jest wstrzymany na {pauseDuration} od {pausedDate}. W okresie wstrzymania można wyświetlać tylko istniejące webinary. W dowolnym momencie możesz wznowić subskrypcję licencji webinarów.",
            "nonAdmin": "Twój plan {planName} jest wstrzymany na {pauseDuration} od {pausedDate}. W okresie wstrzymania można wyświetlać tylko istniejące webinary. W dowolnym momencie możesz skontaktować się z administratorem konta, aby wznowić subskrypcję licencji webinarów."
          },
          "admin": "Twój plan {planName} jest wstrzymany na {pauseDuration}. W okresie wstrzymania można wyświetlić {supportContent} tylko z istniejących webinarów. W dowolnym momencie możesz wznowić subskrypcję licencji webinarów.",
          "nonAdmin": "Twój plan {planName} jest wstrzymany na {pauseDuration}. W okresie wstrzymania można wyświetlić {supportContent} tylko z istniejących webinarów. W dowolnym momencie możesz skontaktować się z administratorem konta, aby wznowić subskrypcję licencji webinarów."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Twoja licencja {planName} zostanie wstrzymana {pausedDate} na {pauseDuration}. Aby nadal prowadzić webinary, przypisz temu użytkownikowi aktywną licencję przed rozpoczęciem okresu wstrzymania. Możesz także anulować wstrzymanie, aby nadal korzystać z tej licencji.",
            "nonAdmin": "Twoja licencja {planName} zostanie wstrzymana {pausedDate} na {pauseDuration}. W okresie wstrzymania możesz wyświetlać tylko istniejące webinary i ich zasoby. Aby kontynuować organizowanie webinarów, skontaktuj się z administratorem konta i poproś go o przypisanie aktywnej licencji do Twojego konta przed rozpoczęciem okresu wstrzymania."
          },
          "active": {
            "admin": "Twoja licencja {planName} jest wstrzymana na {pauseDuration} od {pausedDate}. W okresie wstrzymania można wyświetlać tylko istniejące webinary. W dowolnym momencie możesz wznowić subskrypcję licencji lub przypisać aktywną licencję do swojego konta, aby dalej prowadzić webinary.",
            "nonAdmin": "Twoja licencja {planName} jest wstrzymana na {pauseDuration} od {pausedDate}. W okresie wstrzymania można wyświetlać tylko istniejące webinary. Aby prowadzić webinary w okresie wstrzymania, skontaktuj się z administratorem konta i poproś go o przypisanie aktywnej licencji do Twojego konta."
          }
        },
        "cancel": {
          "active": {
            "admin": "Twoja licencja {planName} zostanie anulowana {cancelDate}. Aby nadal organizować webinary, ponownie aktywuj licencję webinarów lub przypisz aktywną licencję, zanim anulowanie wejdzie w życie. Jeśli nie zostaną podjęte żadne działania, w okresie od {supportStartDate} - {supportEndDate} będziesz mieć okres karencji, aby skontaktować się z obsługą klienta i odzyskać istniejące dane webinarów. Po {dataLossDate} wszystkie dane webinarów powiązane z Twoim kontem zostaną trwale usunięte.",
            "nonAdmin": "Twoja licencja {planName} zostanie anulowana {cancelDate}. Aby nadal organizować webinary, skontaktuj się z administratorem konta, aby ponownie aktywować licencję webinarów lub przypisać aktywną licencję, zanim anulowanie wejdzie w życie. Jeśli nie zostaną podjęte żadne działania, w okresie od {supportStartDate} - {supportEndDate} będziesz mieć okres karencji, aby skontaktować się z obsługą klienta i odzyskać istniejące dane webinarów. Po {dataLossDate} wszystkie dane webinarów powiązane z Twoim kontem zostaną trwale usunięte."
          },
          "expired": {
            "admin": "Twoja licencja {planName} została anulowana. Aby kontynuować organizowanie webinarów, przypisz aktywną licencję temu użytkownikowi. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby pobrać dane istniejących webinarów.",
            "nonAdmin": "Twoja licencja {planName} została anulowana. Aby kontynuować organizowanie webinarów, skontaktuj się z administratorem konta i poproś go o przypisanie aktywnej licencji do Twojego profilu. W okresie od {supportStartDate} do {supportEndDate} skontaktuj się z obsługą klienta, aby pobrać dane istniejących webinarów."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Twoja licencja {planName} zostanie wstrzymana {pausedDate} na {pauseDuration}. W okresie wstrzymania możesz wyświetlać tylko {supportContent} dla wcześniejszych webinarów. Aby nadal mieć dostęp do zasobów webinarów, przypisz temu użytkownikowi aktywną licencję przed rozpoczęciem okresu wstrzymania. Możesz także anulować wstrzymanie, aby nadal korzystać z tej licencji.",
              "nonAdmin": "Twoja licencja {planName} zostanie wstrzymana {pausedDate} na {pauseDuration}. W okresie wstrzymania możesz wyświetlać tylko {supportContent}. Aby nadal mieć dostęp do zasobów webinarów, skontaktuj się z administratorem konta i poproś go o przypisanie aktywnej licencji do Twojego profilu."
            },
            "active": {
              "admin": "Twój plan {planName} jest wstrzymany na {pauseDuration} od {pausedDate}. W okresie wstrzymania możesz wyświetlać tylko {supportContent} istniejących webinarów. Aby nadal mieć dostęp do zasobów webinarów, przypisz aktywną licencję do swojego konta. W dowolnym momencie możesz także wznowić subskrypcję tej licencji.",
              "nonAdmin": "Twój plan {planName} jest wstrzymany na {pauseDuration} od {pausedDate}. W okresie wstrzymania możesz wyświetlać tylko {supportContent} istniejących webinarów. Aby prowadzić webinary w okresie wstrzymania, skontaktuj się z administratorem konta i poproś go o przypisanie aktywnej licencji do Twojego konta."
            }
          },
          "cancel": {
            "active": {
              "admin": "Twój plan {planName} zostanie anulowany {cancelDate}. Aby nadal prowadzić webinary, przypisz aktywną licencję do swojego konta przed momentem anulowania. Możesz ponownie aktywować tę licencję przed {cancelDate}. W okresie od {supportStartDate} do {supportEndDate} możesz skontaktować się z obsługą klienta, aby pobrać {supportContent} istniejących webinarów.",
              "nonAdmin": "Twoja licencja {planName} zostanie anulowana {cancelDate}. Aby nadal organizować webinary, skontaktuj się z administratorem konta, aby ponownie aktywować licencję webinarów lub przypisać aktywną licencję, zanim anulowanie wejdzie w życie. Jeśli nie zostaną podjęte żadne działania, w okresie od {supportStartDate} - {supportEndDate} będziesz mieć okres karencji, aby skontaktować się z obsługą klienta i odzyskać {supportContent} istniejących webinarów. Po {dataLossDate} wszystkie dane webinarów powiązane z Twoim kontem zostaną trwale usunięte."
            },
            "expired": {
              "admin": "Twoja licencja {planName} została anulowana. Aby kontynuować organizowanie webinarów, przypisz aktywną licencję temu użytkownikowi. W okresie od {supportStartDate} do {supportEndDate} skontaktuj się z obsługą klienta, aby pobrać {supportContent} istniejących webinarów.",
              "nonAdmin": "Twoja licencja {planName} została anulowana. Aby kontynuować organizowanie webinarów, skontaktuj się z administratorem konta i poproś go o przypisanie aktywnej licencji do Twojego profilu. W okresie od {supportStartDate} do {supportEndDate} skontaktuj się z obsługą klienta, aby pobrać {supportContent} istniejących webinarów."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "dane",
        "recordingsAndTranscripts": "nagrania i transkrypcje",
        "reports": "raporty",
        "summaries": "podsumowania",
        "dashboard": "pulpity"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "nagrania i transkrypcje poprzednich webinarów",
          "reports": "raporty z poprzednich webinarów",
          "summaries": "podsumowania poprzednich webinarów",
          "dashboard": "pulpity poprzednich webinarów",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Aktywuj plan ponownie",
    "purchasePlan": "Kup plan",
    "removePause": "Usuń wstrzymanie",
    "resumeSubscription": "Wznów subskrypcję",
    "month": "miesiąc",
    "months": "mies.",
    "assignLicense": "Przypisz licencję"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Rozumiem"
    },
    "coachMark": {
      "tipsTitle": "Książka adresowa stanie się Katalogiem klientów",
      "tipsContent": "W wydaniu z października 2026 r. zmieniamy nazwę Książki adresowej na Katalog klientów, aby lepiej oddać jej przeznaczenie. Cała istniejąca funkcjonalność, uprawnienia i przepływy pracy pozostaną bez zmian — nadal będziesz zarządzać listami klientów (książkami adresowymi) i kontaktami tak samo jak dziś."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Obecnie aktualizujemy nasze warunki i polityki",
    "agreeSub": "Kontynuacja korzystania z Zoom oznacza akceptację zaktualizowanych <a href=\"https://www.zoom.us/terms\" target=\"_blank\">warunków świadczenia usług</a> i <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">polityki prywatności</a>.",
    "continue": "Kontynuuj"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Powrót do konta głównego",
      "backLinkedAccount": "Powrót do konta powiązanego",
      "backMyAccount": "Powrót do Moje konto",
      "myAccount": "Moje konto"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion jest już dostępny na Twoim koncie",
      "desc": "Oto niektóre funkcje Custom AI Companion, z których możesz korzystać na swoim koncie:",
      "studioTitle": "AI Studio",
      "studioDesc": "Dostosuj środowisko AI Companion do potrzeb swojej organizacji.",
      "integrationsTitle": "Integracje innych firm",
      "integrationsDesc": "Wykorzystaj aplikacje innych firm, aby usprawnić swoje przepływy pracy.",
      "clipsTitle": "Niestandardowe awatary dla Zoom Clips",
      "clipsDesc": "Pozwól użytkownikom personalizować awatary AI do użycia w ich klipach."
    },
    "coachMark": {
      "licenseTitle": "Masz {0} licencji Custom AI Companion do przypisania",
      "licenseDesc": "Przypisz te licencje w sekcji <b>Zarządzanie użytkownikami</b>, aby użytkownicy mogli zacząć korzystać z zaawansowanych możliwości AI Companion.",
      "settingTitle": "Sprawdź ustawienia Custom AI Companion dla swojego konta",
      "settingDesc": "Skonfiguruj ustawienia każdej funkcji Custom AI w sekcji <b>Ustawienia konta</b>. <a href=\"/account/setting?tab=aicompanion\">Przejdź do ustawień</a>",
      "groupSettingTitle": "Sprawdź ustawienia Custom AI dla swojej grupy",
      "groupSettingDesc": "Skonfiguruj ustawienia każdej funkcji Custom AI w sekcji <b>Ustawienia grupy</b>. <a href=\"/account/group\">Przejdź do ustawień</a>"
    },
    "common": {
      "learnMore": "Dowiedz się więcej",
      "quickTour": "Weź udział w krótkiej prezentacji",
      "remindLater": "Przypomnij później",
      "dismiss": "Odrzuć",
      "next": "Dalej",
      "back": "Wstecz",
      "gotIt": "Rozumiem",
      "goToSetting": "Przejdź do ustawienia"
    },
    "aiPanelToast": "Włącz ustawienie <b>Panel AI w Zoom Workplace</b>, aby zacząć korzystać ze wszystkich funkcji Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Rozumiem",
      "next": "Dalej",
      "remindMeLater": "Przypomnij później",
      "waffleMenuTitle": "Witamy w nowym interfejsie internetowym Zoom",
      "waffleMenuDesc": "Uzyskuj dostęp do produktów Zoom z dowolnego miejsca dzięki nowemu <b>menu produktów.</b>",
      "profileMenuTitle": "Moje konto",
      "profileMenuDesc": "Znajdź swój profil i ustawienia osobiste w sekcji <b>Moje konto.</b>",
      "personalTitle": "Uzyskaj dostęp do wszystkiego, czego potrzebujesz",
      "personalDesc": "Sekcja <b>Moje konto</b> obejmuje Twój profil, ustawienia, transkrypcje spotkań i nie tylko.",
      "adminCenterTitle": "Znajdź ustawienia organizacji w Centrum administracyjnym",
      "adminCenterDesc": "Nowe <b>Centrum administracyjne</b> pozwala konfigurować produkty i dostosowywać ustawienia dla całej organizacji.",
      "adminMenuForTitle": "Korzystaj z Centrum administracyjnego jak profesjonalista",
      "adminMenuForAccountSettings": "Sekcja <b>Ustawienia</b> umożliwia dostęp do domyślnych ustawień produktów dla wszystkich w Twojej organizacji.",
      "adminMenuForContentManagementItem": "W sekcji <b>Zarządzanie treścią</b> możesz zarządzać wszystkimi treściami generowanymi przez użytkowników.",
      "adminMenuForConfigureProductsItem": "Sekcja <b>Konfiguracja produktów</b> umożliwia konfigurowanie produktów i wykonywanie zadań administratora.",
      "adminMenuForNoItems": "Nowe centrum administracyjne ułatwia dostęp do ustawień konta i produktów oraz zarządzanie nimi. Możesz też przypinać wybrane elementy, aby szybciej do nich wracać.",
      "tryNewExperience": "Wypróbuj nowy interfejs",
      "tryNewExperienceDetail": "Wypróbuj! Zawsze możesz wrócić do tego klasycznego interfejsu.",
      "tryNewExperienceTitle": "Nowy wygląd Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Wszelkie prawa zastrzeżone.",
    "terms": "Warunki",
    "privacy": "Prywatność",
    "trust_center": "Centrum zaufania",
    "acceptable_use_guidelines": "Wytyczne dotyczące dopuszczalnego użytkowania",
    "legal": "Informacje prawne",
    "do_not_sell_my_personal_information": "Twoje wybory dotyczące prywatności",
    "cookie_preferences": "Preferencje plików cookie",
    "pricing": "Plany i cennik",
    "feedback": "Opinie",
    "contact_us": "Skontaktuj się z nami"
  },
  "termChange": {
    "changeTerm": {
      "title": "Umowa o zmianę okresu odnowienia",
      "quoteNumbers": "Zmodyfikowany(-e) formularz(-e) zamówienia - {0}",
      "content1": "Akceptując niniejsze warunki, Klient zgadza się zmodyfikować istniejący okres odnowienia subskrypcji dla wszystkich formularzy zamówienia między Zoom Communications, Inc. („Zoom”) a Klientem, zmieniając zadeklarowany okres z odnowienia z miesiąca na miesiąc na {0}. W zamian za to zobowiązanie Zoom zgadza się utrzymać bieżące ceny Klienta przez czas trwania pierwszego nowego okresu odnowienia.",
      "content2": "Klient rozumie, że nowy okres odnowienia wynoszący {0} obowiązuje po kliknięciu przez Klienta przycisku „Akceptuję” poniżej oraz że nowy okres odnowienia rozpocznie się w dniu następującym po zakończeniu bieżącego okresu odnowienia z miesiąca na miesiąc. Ten nowy okres odnowienia będzie obowiązywał wszystkie formularze zamówienia aktualnie obowiązujące w stosunku do Zoom, a wszystkie przyszłe okresy odnowienia na podstawie tych formularzy zamówienia będą miały tę samą długość.",
      "content3": "Klient potwierdza, że jedyną wprowadzaną zmianą jest okres odnowienia oraz że wszystkie pozostałe warunki każdego formularza zamówienia aktualnie obowiązującego w stosunku do Zoom pozostają niezmienione i w pełni obowiązujące zgodnie z ich postanowieniami.",
      "content4": "Potwierdzasz również, że jest to zobowiązanie umowne między Klientem a Zoom.",
      "agreementText": "Klikając „Akceptuję”, potwierdzasz, że jesteś upoważniony(-a) do wprowadzenia tej zmiany w imieniu Klienta oraz że Klient zgadza się na warunki szczegółowo określone powyżej.",
      "IDecline": "Odrzucam",
      "IAccept": "Akceptuję"
    },
    "unableToChangeTerm": {
      "title": "Nie można zmienić okresu odnowienia",
      "content": "Twoje konto nie kwalifikuje się do aktualizacji okresu odnowienia. <a target=\"_blank\" href=\"{0}\">Skontaktuj się z nami</a>, jeśli to błąd.",
      "acceptedTitle": "Okres odnowienia został przedłużony",
      "acceptedContent": "Wcześniej zaakceptowano warunki odnowienia. Nie są wymagane żadne dalsze działania.",
      "GotIt": "Rozumiem"
    },
    "termLengthUpdated": "Długość okresu odnowienia zaktualizowano do {0} mies.",
    "termLengthUnchanged": "Długość okresu bez zmian.",
    "errorInfo": "Wystąpił błąd serwera. Spróbuj ponownie.",
    "x12MonthTerm": "okres dwunastu (12) miesięcy",
    "x24MonthTerm": "okres dwudziestu czterech (24) miesięcy",
    "x12MonthTermPlural": "dwanaście (12) miesięcy",
    "x24MonthTermPlural": "dwadzieścia cztery (24) miesiące"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Konto ma zostać zaktualizowane do <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">nowego środowiska internetowego Zoom</a> w dniu {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Sprawdź, kiedy zaktualizować</a>"
    },
    "completed": {
      "content": "Nowe środowisko internetowe Zoom jest teraz aktywne dla wszystkich użytkowników konta. Użytkownicy zobaczą zaktualizowany interfejs przy następnym logowaniu."
    }
  }
}
